export const scrollToSection = (selector) => {
  const el = document.querySelector(selector);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const WHATSAPP_URL =
  "https://wa.me/918604796110?text=Hi%20Ayan%2C%20I%20saw%20your%20portfolio%20and%20would%20like%20to%20discuss%20a%20video%20editing%20project.";

export const styleWhatsApp = (style, title) =>
  `https://wa.me/918604796110?text=${encodeURIComponent(
    `Hi Ayan, I loved your ${style} edit "${title}" on your portfolio — I want this style for my content.`
  )}`;
